var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-124 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(124 275)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.783 2.265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.038-1H20.4a2.04,2.04,0,0,1,2.038,2.038V20.4A2.04,2.04,0,0,1,20.4,22.433H1.038A2.04,2.04,0,0,1-1,20.4V1.038A2.04,2.04,0,0,1,1.038-1ZM20.4,20.4V1.038H1.036V20.4Z",
    transform: "translate(128 279.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.019,5.094A1.019,1.019,0,0,1-1,4.075V1.019a1.019,1.019,0,0,1,2.038,0V4.075A1.019,1.019,0,0,1,.019,5.094Z",
    transform: "translate(144.301 276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.019,5.094A1.019,1.019,0,0,1-1,4.075V1.019a1.019,1.019,0,0,1,2.038,0V4.075A1.019,1.019,0,0,1,.019,5.094Z",
    transform: "translate(133.094 276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.414,1.038H.019A1.019,1.019,0,1,1,.019-1h21.4a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(128 284.132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.695,16.872H8.177V14.354h2.517Zm5.035,0H13.212V14.354h2.517Zm5.035,0H18.247V14.354h2.517Zm-10.07,5.035H8.177V19.389h2.517Zm5.035,0H13.212V19.389h2.517Z",
    transform: "translate(124.246 274.233)",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.79bd622cd500288cacd211f0ebe7e2af.svg";
export { ForwardRef as ReactComponent };